import React from "react";
import "../../../../../Assets/css/common.css"; 
import LoadingIndicator from "components/shared/LoadingIndicator";
import { PulseLoader } from "react-spinners";

function CommonButtonNew({
    text = "button",
    onClick,
    className = "",
    icon = null,
    iconPosition = "left",
    style,
    type = "button",
    loading,
    disabled = false
}) {
    return (
        <button
            type={type}
            disabled={disabled}
            className={`${className} d-flex align-items-center gap-2`}
            onClick={onClick}
            style={{ ...style }}
        > 
            {
                loading ? <PulseLoader color="#fff" size={10} /> : <>
                    {icon && iconPosition === "left" && icon}
                    <span>{text}</span>
                    {icon && iconPosition === "right" && icon}
                </>
            }

        </button>

    );
}

export default CommonButtonNew;
